import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { ButtonEdit } from '../app-button/button'
import style from './settingList.style'
import Typography from '@material-ui/core/Typography'

const SettingList = ({ classes, username, avatar, accounts, prevUrl }) => {
  const account = accounts.filter(account => account.selected)

  const property = account[0].web_properties.filter(
    property => property.selected
  )

  const view = property[0].views.filter(view => view.selected)

  const handleBack = () => {
    location.href = prevUrl
  }

  return (
    <section className={classes.wrap}>
      <ul className={classes.list}>
        <li className={classes.user}>
          <Avatar alt={username} src={avatar} className={classes.avatar} />
          <span>{username}</span>
        </li>

        <Typography className={classes.item} component="li" variant="body1">
          {account[0].name}
        </Typography>

        <Typography className={classes.item} component="li" variant="body1">
          {property[0].name}
        </Typography>

        <Typography className={classes.item} component="li" variant="body1">
          {view[0].name}
        </Typography>
      </ul>
      <ButtonEdit className={classes.settingEdit} handleClick={handleBack} />
    </section>
  )
}

export default style(SettingList)
